export const translations = {
  en: {
    "nav.features": "Features",
    "nav.pricing": "Pricing",
    "nav.developers": "Developers",
    "nav.contact": "Contact",
    "nav.backHome": "Back to home",
    "nav.login": "Log in",
    "nav.start": "Start for Free",
    "hero.badge": "Traffic protection built in",
    "hero.title": "Every Click. Protected.",
    "hero.subtitle":
      "Create smarter links, dynamic QR codes, and secure digital journeys with real-time analytics and intelligent traffic protection.",
    "hero.cta.primary": "Start for Free",
    "hero.cta.secondary": "View Demo",
    "auth.welcome": "Welcome back",
    "auth.createAccount": "Create your account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Full name",
    "auth.login": "Log in",
    "auth.register": "Create account",
    "auth.forgot": "Forgot password?",
    "auth.noAccount": "Don't have an account?",
    "auth.haveAccount": "Already have an account?",
    "auth.signup": "Sign up",
    "dash.overview": "Overview",
    "dash.links": "Smart Links",
    "dash.analytics": "Analytics",
    "dash.settings": "Settings",
    "dash.logout": "Log out",
    "links.new": "New Smart Link",
    "links.empty": "No smart links yet",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
  },
  id: {
    "nav.features": "Fitur",
    "nav.pricing": "Harga",
    "nav.developers": "Developer",
    "nav.contact": "Kontak",
    "nav.backHome": "Kembali ke beranda",
    "nav.login": "Masuk",
    "nav.start": "Mulai Gratis",
    "hero.badge": "Proteksi trafik bawaan",
    "hero.title": "Setiap Klik. Terlindungi.",
    "hero.subtitle":
      "Buat tautan yang lebih pintar, kode QR dinamis, dan perjalanan digital yang aman dengan analitik real-time dan proteksi trafik cerdas.",
    "hero.cta.primary": "Mulai Gratis",
    "hero.cta.secondary": "Lihat Demo",
    "auth.welcome": "Selamat datang kembali",
    "auth.createAccount": "Buat akun Anda",
    "auth.email": "Email",
    "auth.password": "Kata sandi",
    "auth.name": "Nama lengkap",
    "auth.login": "Masuk",
    "auth.register": "Buat akun",
    "auth.forgot": "Lupa kata sandi?",
    "auth.noAccount": "Belum punya akun?",
    "auth.haveAccount": "Sudah punya akun?",
    "auth.signup": "Daftar",
    "dash.overview": "Ringkasan",
    "dash.links": "Smart Links",
    "dash.analytics": "Analitik",
    "dash.settings": "Pengaturan",
    "dash.logout": "Keluar",
    "links.new": "Smart Link Baru",
    "links.empty": "Belum ada smart link",
    "common.save": "Simpan",
    "common.cancel": "Batal",
    "common.delete": "Hapus",
  },
};
